/**
 * iurop-quick-add.js — Añadir al carrito desde fuera del drawer (Glucody).
 * Cualquier [data-quick-add="<variant_id>"] (cards, hero, upsells) añade
 * 1 ud. por /cart/add.js y dispara `cart:updated` → iurop-cart-drawer.js
 * re-pinta el sidecart y lo abre. Las cards con talla obligatoria abren un
 * modal; pulsar una talla añade directamente esa variante y abre el carrito.
 * Sin JS, el enlace navega a la ficha.
 */
(function () {
  'use strict';

  function closeModal(modal) {
    if (!modal) return;
    if (typeof modal.close === 'function' && modal.open) modal.close();
    else modal.removeAttribute('open');
    document.body.classList.remove('quick-add-size-open');
  }

  function addVariant(source, variantId, fallbackUrl, modal) {
    if (!variantId || source.classList.contains('is-loading')) return;

    // Guardia del pack de muestras (iurop-cart-drawer.js): bloquea combinaciones
    // pack+productos y muestra el aviso — sin llegar a llamar a /cart/add.
    if (window.GlucodyCartGuard && !window.GlucodyCartGuard.check(variantId)) return;

    source.classList.add('is-loading');
    if (modal) {
      modal.classList.add('is-loading');
      modal.setAttribute('aria-busy', 'true');
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed');
        return res.json();
      })
      .then(function () {
        closeModal(modal);
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        if (fallbackUrl) window.location.href = fallbackUrl;
      })
      .then(function () {
        source.classList.remove('is-loading');
        if (modal) {
          modal.classList.remove('is-loading');
          modal.removeAttribute('aria-busy');
        }
      });
  }

  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-quick-add-modal-close]');
    if (close) {
      e.preventDefault();
      closeModal(close.closest('[data-quick-add-modal]'));
      return;
    }

    var modalBackdrop = e.target.matches('[data-quick-add-modal]') ? e.target : null;
    if (modalBackdrop) {
      closeModal(modalBackdrop);
      return;
    }

    var option = e.target.closest('[data-quick-add-option]');
    if (option) {
      e.preventDefault();
      if (option.disabled) return;
      var optionModal = option.closest('[data-quick-add-modal]');
      addVariant(
        option,
        option.getAttribute('data-quick-add-option'),
        option.getAttribute('data-product-url'),
        optionModal
      );
      return;
    }

    var modalTrigger = e.target.closest('[data-quick-add-modal-trigger]');
    if (modalTrigger) {
      e.preventDefault();
      var triggerCard = modalTrigger.closest('.glucody-product-card');
      var sizeModal = triggerCard && triggerCard.querySelector('[data-quick-add-modal]');
      if (!sizeModal) {
        window.location.href = modalTrigger.getAttribute('href');
        return;
      }
      sizeModal._quickAddTrigger = modalTrigger;
      document.body.classList.add('quick-add-size-open');
      if (typeof sizeModal.showModal === 'function') sizeModal.showModal();
      else sizeModal.setAttribute('open', '');
      var firstSize = sizeModal.querySelector('[data-quick-add-option]:not([disabled])');
      if (firstSize) firstSize.focus({ preventScroll: true });
      return;
    }

    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    addVariant(btn, btn.getAttribute('data-quick-add'), btn.getAttribute('href'));
  });

  document.addEventListener('close', function (e) {
    if (!e.target.matches || !e.target.matches('[data-quick-add-modal]')) return;
    document.body.classList.remove('quick-add-size-open');
  }, true);
})();
